import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import com1 from '../../assets/partners/partner-01.svg';
import com2 from '../../assets/partners/partner-02.svg';
import com3 from '../../assets/partners/partner-03.svg';
import com4 from '../../assets/partners/partner-04.svg';
import com5 from '../../assets/partners/partner-05.svg';
import com6 from '../../assets/partners/partner-06.svg';
import com7 from '../../assets/partners/partner-07.svg';

const Partners = () => {
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        lazyLoad: true,
        autoplay: true,
        autoplaySpeed: 500,
        pauseOnHover: true,
        swipeToSlide: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    return (
        <div className="my-8 px-8 mx-auto w-11/12 shadow-custom rounded-2xl">
            <Slider {...settings} >
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.yatra.com/" target="_blank">
                        <img className="block w-full img-gray" src={com1} alt="yatra" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.expedia.com/" target="_blank">
                        <img className="block w-full img-gray" src={com2} alt="expedia" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.qatarairways.com/" target="_blank">
                        <img className="block w-full img-gray" src={com3} alt="qatar" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.trivago.com/" target="_blank">
                        <img className="block w-full img-gray" src={com4} alt="trivago" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.hotwire.com" target="_blank">
                        <img className="block w-full img-gray" src={com5} alt="hotwire" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.carnival.com/" target="_blank">
                        <img className="block w-full img-gray" src={com6} alt="" />
                    </a>
                </div>
                <div className="px-8 mx-8">
                    <a className="block px-4 md:px-8 2xl:px-16" href="https://www.airbnb.com/" target="_blank">
                        <img className="block w-full img-gray" src={com7} alt="airbnb" />
                    </a>
                </div>
            </Slider>
        </div>
    );
};

export default Partners;